(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      if (document.body.classList.contains('template-index') && this.querySelector('.pf-d1-header')) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-collection"] && !Shopify.designMode) return;
  try {
    
  function initPersaFilters(root) {
    root.querySelectorAll('.pf-filters:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const toggle = form.querySelector('.pf-filter-toggle');
      const panel = form.querySelector('.pf-filters__panel');
      if (toggle && panel) {
        panel.hidden = panel.hasAttribute('data-collapsed');
        toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
      }
      form.querySelector('[name="sort_by"]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('formdata', event => { for (const [name, value] of [...event.formData.entries()]) { if (value === '') event.formData.delete(name); } });
    });
  }
  initPersaFilters(document);
  document.addEventListener('shopify:section:load', event => initPersaFilters(event.target));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    // Back/forward cache retains edits made before navigation; restore server-applied filters.
    requestAnimationFrame(() => document.querySelectorAll('.pf-filters').forEach(form => form.reset()));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-d1-includes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-includes')) {
    customElements.define('pf-includes', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.controls = [...this.querySelectorAll('[data-item]')];
        this.photos = [...this.querySelectorAll('[data-photo]')];
        this.caption = this.querySelector('[data-caption]');
        this.back = this.querySelector('[data-reset]');
        this.pinned = 0;
        const header = document.querySelector('.shopify-section-header');
        const visual = this.querySelector('.pf-includes__visual');
        this.resizeObserver = new ResizeObserver(() => {
          this.style.setProperty('--pf-includes-header-height', (header ? header.getBoundingClientRect().height : 0) + 'px');
          this.style.setProperty('--pf-includes-visual-height', visual.getBoundingClientRect().height + 'px');
        });
        if (header) this.resizeObserver.observe(header);
        this.resizeObserver.observe(visual);
        this.closest('.pf-d1-includes').querySelector('[data-includes-box]').addEventListener('click', () => {
          this.pinned = 5;
          this.show(5);
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.querySelector('.pf-includes__frame').scrollIntoView({ behavior, block: 'start' });
        }, { signal: this.controller.signal });
        this.controls.forEach(control => {
          control.addEventListener('click', () => {
            this.pinned = Number(control.dataset.item);
            this.show(this.pinned);
            if (!control.classList.contains('pf-includes__pin') && window.matchMedia('(max-width: 749px)').matches) {
              const frame = this.querySelector('.pf-includes__frame');
              const bounds = frame.getBoundingClientRect();
              if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
                const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
                frame.scrollIntoView({ behavior, block: 'start' });
              }
            }
          }, { signal: this.controller.signal });
          if (control.classList.contains('pf-includes__row')) {
            control.addEventListener('pointerenter', event => {
              if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px) and (hover: hover)').matches) this.show(Number(control.dataset.item));
            }, { signal: this.controller.signal });
            control.addEventListener('focus', () => this.show(Number(control.dataset.item)), { signal: this.controller.signal });
          }
        });
        this.addEventListener('pointerleave', () => this.show(this.pinned), { signal: this.controller.signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.show(this.pinned);
        }, { signal: this.controller.signal });
        this.back.addEventListener('click', () => this.reset(), { signal: this.controller.signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); this.reset(); }
        }, { signal: this.controller.signal });
        this.dataset.ready = '';
      }
      show(item) {
        const view = ({ 2: 'aquapack', 3: 'details', 4: 'details', 5: 'box' })[item] || 'bouquet';
        this.dataset.view = view;
        this.dataset.selected = String(item);
        this.photos.forEach(photo => { photo.hidden = photo.dataset.photo !== view; });
        this.controls.forEach(control => {
          if (control.hasAttribute('aria-pressed')) control.setAttribute('aria-pressed', String(Number(control.dataset.item) === item));
        });
        const row = this.querySelector('.pf-includes__row[data-item="' + item + '"]');
        this.caption.textContent = row ? row.dataset.detailCaption : this.caption.dataset.defaultCaption;
        this.back.hidden = view === 'bouquet';
      }
      reset() {
        this.pinned = 0;
        const row = this.querySelector('.pf-includes__row[data-item="1"]');
        if (this.contains(document.activeElement)) row.focus({ preventScroll: true });
        this.show(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-delivery-services-preview"]) return;
  try {
    
  if (!customElements.get('pf-delivery-services-preview')) {
    customElements.define('pf-delivery-services-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.onSelectionChange) return;
        this.onSelectionChange = () => this.updateSummary();
        this.addEventListener('change', this.onSelectionChange);
        this.updateSummary();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onSelectionChange);
        this.onSelectionChange = null;
      }

      updateSummary() {
        const input = this.querySelector('input[type="radio"]:checked');
        if (!input) return;
        const priceCents = Number(input.dataset.priceCents);
        if (!Number.isSafeInteger(priceCents) || priceCents < 0) return;
        this.querySelector('[data-selected-label]').textContent = input.dataset.label;
        this.querySelector('[data-selected-detail]').textContent = input.dataset.detail;
        this.querySelector('[data-selected-price]').textContent = input.dataset.priceLabel;
        this.dataset.selectedService = input.value;
        this.dataset.selectedPriceCents = String(priceCents);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-hero-pan')) {
    customElements.define('pf-hero-pan', class extends HTMLElement {
      connectedCallback() {
        if (this.disconnectPan) return;
        const image = this.querySelector('.pf-hero__image');
        const ratio = Number(this.dataset.imageRatio);
        if (!image || !(ratio > 0)) return;
        const hero = this.closest('.pf-hero');
        const track = hero.parentElement;
        const header = document.querySelector('.shopify-section-header:has(sticky-header)');
        const media = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
        const native = CSS.supports('animation-timeline: scroll(root block)') && CSS.supports('animation-range: 0px 320px');
        let frame = 0;
        let distance = 0;
        let start = 0;
        const draw = () => {
          frame = 0;
          const progress = Math.min(1, Math.max(0, (window.scrollY - start) / 320));
          this.style.setProperty('--pf-pan-offset', `${-distance * progress}px`);
        };
        const scroll = () => {
          if (!frame) frame = requestAnimationFrame(draw);
        };
        const stop = () => {
          window.removeEventListener('scroll', scroll);
          cancelAnimationFrame(frame);
          frame = 0;
          delete this.dataset.panMode;
          delete track.dataset.reveal;
          ['--pf-reveal-top', '--pf-reveal-start', '--pf-reveal-end'].forEach(key => track.style.removeProperty(key));
          ['--pf-pan-height', '--pf-pan-start', '--pf-pan-distance', '--pf-pan-offset'].forEach(key => this.style.removeProperty(key));
        };
        const measure = () => {
          if (!media.matches) {
            stop();
            return;
          }
          const bounds = this.getBoundingClientRect();
          const height = Math.max(bounds.height, bounds.width / ratio);
          const overflow = height - bounds.height;
          if (overflow < 1) {
            stop();
            return;
          }
          const top = Math.min(header?.offsetHeight || 0, window.innerHeight - hero.offsetHeight);
          start = Math.max(0, track.getBoundingClientRect().top + window.scrollY - top);
          distance = overflow * 0.44;
          track.style.setProperty('--pf-reveal-top', `${top}px`);
          track.style.setProperty('--pf-reveal-start', `${start}px`);
          track.style.setProperty('--pf-reveal-end', `${start + 320}px`);
          track.dataset.reveal = '';
          this.style.setProperty('--pf-pan-height', `${height}px`);
          this.style.setProperty('--pf-pan-start', `${-overflow * 0.28}px`);
          this.style.setProperty('--pf-pan-distance', `${-distance}px`);
          this.dataset.panMode = native ? 'native' : 'fallback';
          if (!native) {
            draw();
            window.addEventListener('scroll', scroll, { passive: true });
          }
        };
        const observer = new ResizeObserver(measure);
        observer.observe(this);
        observer.observe(hero);
        if (header) observer.observe(header);
        media.addEventListener('change', measure);
        window.addEventListener('resize', measure, { passive: true });
        window.addEventListener('pageshow', measure);
        this.disconnectPan = () => {
          stop();
          observer.disconnect();
          media.removeEventListener('change', measure);
          window.removeEventListener('resize', measure);
          window.removeEventListener('pageshow', measure);
          this.disconnectPan = null;
        };
        measure();
      }
      disconnectedCallback() {
        this.disconnectPan?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-business-reviews')) {
    customElements.define('pf-business-reviews', class extends HTMLElement {
      connectedCallback() {
        const widget = this.querySelector('.elfsight-app-550acfd3-a181-4138-a8b4-aca165a6aab2');
        if (!widget) return;
        this.load = () => {
          this.visibilityObserver?.disconnect();
          if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
            const script=document.createElement('script');script.src='https://elfsightcdn.com/platform.js';script.async=true;document.head.append(script);
          }
        };
        this.querySelector('.pf-reviews-load')?.addEventListener('click',this.load);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting))this.load();},{rootMargin:'500px 0px'});
          this.visibilityObserver.observe(this);
        } else this.load();
        const removeBusinessProductMarkup = () => {
          widget.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
            try {
              const data = JSON.parse(script.textContent);
              if (data['@type'] === 'Product' && data.aggregateRating) script.remove();
            } catch {}
          });
        };
        this.observer?.disconnect();
        this.observer = new MutationObserver(removeBusinessProductMarkup);
        this.observer.observe(widget, { childList: true, subtree: true, characterData: true });
        removeBusinessProductMarkup();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.querySelector('.pf-reviews-load')?.removeEventListener('click',this.load);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-workshop-gallery"] && !Shopify.designMode) return;
  try {
    
  function initializeWorkshopGalleries(root) {
    root.querySelectorAll('.pf-workshop').forEach((gallery) => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const track = gallery.querySelector('.pf-workshop__photos');
      const controls = gallery.querySelector('.pf-workshop__controls');
      const buttons = controls.querySelectorAll('button');
      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        controls.hidden = maxScroll < 2;
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft >= maxScroll - 2;
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        const card = track.querySelector('.pf-workshop__card');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({ left: step * Number(button.dataset.workshopDirection), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      gallery.querySelector('.pf-workshop__head > a').addEventListener('click', () => {
        gallery.querySelector('details').open = true;
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(gallery)) {
          observer.disconnect();
        }
      });
      update();
    });
  }
  initializeWorkshopGalleries(document);
  document.addEventListener('shopify:section:load', (event) => initializeWorkshopGalleries(event.target));

  } catch(e) { console.error(e); }
})();
})();
